"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Lookup
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LookupListToJSON = exports.LookupListFromJSONTyped = exports.LookupListFromJSON = void 0;
const _1 = require("./");
function LookupListFromJSON(json) {
    return LookupListFromJSONTyped(json, false);
}
exports.LookupListFromJSON = LookupListFromJSON;
function LookupListFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'category': json['category'],
        'values': (json['values'].map(_1.LookupValueFromJSON)),
    };
}
exports.LookupListFromJSONTyped = LookupListFromJSONTyped;
function LookupListToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'category': value.category,
        'values': (value.values.map(_1.LookupValueToJSON)),
    };
}
exports.LookupListToJSON = LookupListToJSON;
//# sourceMappingURL=LookupList.js.map